<template lang="html">

  <section class="ficha -estudiante">

    <template v-if="!!data">

     <h2 class="ficha-title" :style="styles.colorBasic">Estudiante</h2>

     <article class="group">

      <h3 class="group-title" :style="styles.colorBasic">Datos personales</h3>

      <div class="contenedor-data" v-if="!!data.Personales.nombre">
        <h4 class="data-title" :style="styles.colorBasic">Nombre</h4>
        <p>{{data.Personales.nombre}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.apellidos">
        <h4 class="data-title" :style="styles.colorBasic">Apellidos</h4>
        <p>{{data.Personales.apellidos}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.email">
        <h4 class="data-title" :style="styles.colorBasic">Email</h4>
        <p><a :href="'mailto:'+data.Personales.email">{{data.Personales.email}}</a></p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.movil">
        <h4 class="data-title" :style="styles.colorBasic">Móvil</h4>
        <p><a :href="'tel:'+data.Personales.movil">{{data.Personales.movil}}</a></p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.telefono">
        <h4 class="data-title" :style="styles.colorBasic">Fijo</h4>
        <p><a :href="'tel:'+data.Personales.telefono">{{data.Personales.telefono}}</a></p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.fecha_nacimiento">
        <h4 class="data-title" :style="styles.colorBasic">Fecha de nacimiento</h4>
        <p>{{data.Personales.fecha_nacimiento}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.nacionalidad">
        <h4 class="data-title" :style="styles.colorBasic">País de nacionalidad</h4>
        <p>{{data.Personales.nacionalidad}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.direccion">
        <h4 class="data-title" :style="styles.colorBasic">Dirección</h4>
        <p>{{data.Personales.direccion}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.ciudad">
        <h4 class="data-title" :style="styles.colorBasic">Población</h4>
        <p>{{data.Personales.ciudad}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.provincia">
        <h4 class="data-title" :style="styles.colorBasic">Provincia</h4>
        <p>{{data.Personales.provincia}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.CP">
        <h4 class="data-title" :style="styles.colorBasic">Código postal</h4>
        <p>{{data.Personales.CP}}</p>
      </div>

      <div class="contenedor-data" v-if="!!!brand.hideDiscapacidad">
        <h4 class="data-title" :style="styles.colorBasic">Discapacidad</h4>
        <p>{{(data.Personales.discapacidad) ? 'Sí' : 'No'}}</p>
      </div>

    </article>

    <article class="group" v-if="!!data.documentos && !!!brand.onlyShowCVinDocs">

     <h3 class="group-title" :style="styles.colorBasic">Documentos</h3>

     <template v-for="doc in data.documentos">
       <div class="contenedor-data">
        <h4 class="data-title" :style="styles.colorBasic">{{(!!doc.nombre) ? doc.nombre : documentos[doc.tipo]}}</h4>
        <p class="descargar"><a :href="doc.enlace" target="_blank">Descargar</a></p>
      </div>
    </template>


  </article>

  <article class="group" >

    <template v-if="!!data.academicos && !brand.hideDatosAcademicos">

    <h3 class="group-title" :style="styles.colorBasic">Datos acádemicos en curso</h3>

    <div class="contenedor-data -full" v-for="academico in data.academicos"> 
      <div class="full-children -full">
         <h4 class="data-title" :style="styles.colorBasic">Titulación</h4>
         <p>{{academico.titulacion}}</p>
      </div>
      <div class="full-children">
        <h4 class="data-title" :style="styles.colorBasic">Matriculado de prácticas</h4>
        <p>{{(academico.matriculadoOracticas) ? 'Sí' : 'No'}}</p>
      </div>
      <div class="full-children">
        <h4 class="data-title" :style="styles.colorBasic">Prácticas pendientes</h4>
        <p>{{(academico.PracticasPendientes) ? 'Sí' : 'No'}}</p>
      </div>
    </div>

  </template>


  <div class="contenedor-data">
    <arrow-link :text="'Ver CV del estudiante'" :external="true" :to="data.Personales.urlCV" :blank="true"></arrow-link>
  </div>

</article>

<template v-if="data.autorizacionPracticas.length > 0 && !brand.hideautorizacionPorCuatrimestre">

  <article class="group" v-for="(autorizacion, key) in data.autorizacionPracticas">

    <h3 class="group-title" :style="styles.colorBasic">Autorización por Cuatrimestre</h3>

    <div class="contenedor-data -full">
      
       <div class="full-children -full" v-if="key == 0 && !!data.autorizacionPorCuatrimestre">
         <p>{{data.autorizacionPorCuatrimestre}}</p>
      </div>

      <div class="full-children" v-if="!!autorizacion.anio">
        <h4 class="data-title" :style="styles.colorBasic">Año</h4>
        <p>{{autorizacion.anio}}</p>
      </div>
      <div class="full-children" v-if="!!autorizacion.codigoEstudio">
        <h4 class="data-title" :style="styles.colorBasic">Código de estudio</h4>
        <p>{{autorizacion.codigoEstudio}}</p>
      </div>
      <div class="full-children" v-if="!!autorizacion.atutorizacion">
        <h4 class="data-title" :style="styles.colorBasic">Autorización</h4>
        <p>{{(autorizacion.atutorizacion) ? 'Sí' : 'No'}}</p>
      </div>
      <div class="full-children" v-if="!!autorizacion.periodo">
        <h4 class="data-title" :style="styles.colorBasic">Periodo</h4>
        <p>{{autorizacion.periodo}}</p>
      </div>
      <div class="full-children" v-if="!!autorizacion.fechaResolucion">
        <h4 class="data-title" :style="styles.colorBasic">Fecha de resolución</h4>
        <p>{{autorizacion.fechaResolucion}}</p>
      </div>
      <div class="full-children" v-if="!!autorizacion.horas">
        <h4 class="data-title" :style="styles.colorBasic">Horas</h4>
        <p>{{autorizacion.horas}}</p>
      </div>
    </div>

  </article>

</template>

</template>


</section>

</template>

<script lang="js">


  import {mapGetters, mapActions} from 'vuex';

  import onlyArrow  from '@/components/parts/icons/only-arrow';
  import arrowlink  from '@/components/parts/icons/arrow-link';

  export default  {
    name: 'ficha-estudiante',
    props : ['data'],
    computed :{
      ...mapGetters({
        styles : 'getStyles',
        documentos :'getDocumentos',
        brand : 'getBrand'
      })
    },
    components : {
      'only-arrow' : onlyArrow,
      'arrow-link' : arrowlink,
    }
  }
</script>

<style scoped lang="scss">
  .ficha-estudiante {

  }
</style>



// WEBPACK FOOTER //
// src/components/views/ficha-estudiante.vue